export default __webpack_public_path__ + "static/media/quality.a7a70114.svg";